import { MultiSkillTag, OccupationSkillTag, SingleSkillTag } from '../../domain/model/skill_tag';

// single skill tag
interface ISingleSkillTagListGetResponse {
    singleSkillTags: SingleSkillTag[];
}

class SingleSkillTagListGetResponse implements ISingleSkillTagListGetResponse {
    public singleSkillTags: SingleSkillTag[];
}


// multi skill tag
interface IMultiSkillTagListGetResponse {
    multiSkillTags: MultiSkillTag[];
}

class MultiSkillTagListGetResponse implements IMultiSkillTagListGetResponse {
    public multiSkillTags: MultiSkillTag[];
}

// occupation skill tag
interface IOccupationSkillTagListGetResponse {
    occupationSkillTags: OccupationSkillTag[];
}

class OccupationSkillTagListGetResponse implements IOccupationSkillTagListGetResponse {
    public occupationSkillTags: OccupationSkillTag[];
}

export {
    SingleSkillTagListGetResponse,
    MultiSkillTagListGetResponse,
    OccupationSkillTagListGetResponse
}



// WEBPACK FOOTER //
// ./src/presentation/response/skill_tag_response.ts